<template>
  <v-form @submit.prevent ref="add_form">
    <v-col
        cols="12"
    >
      <v-card>
        <v-card-title class="headline">
          {{ title }}
        </v-card-title>
        <v-divider class="mx-3"></v-divider>
        <v-row
            justify="center"
            align-content="center"
        >
          <v-col cols="3">
            <v-subheader>担当者コード<span class="required_mark">*</span></v-subheader>
          </v-col>
          <v-col cols="8" class="input-col">
            <v-text-field
                outlined
                dense
                name="user_code"
                type="text"
                placeholder="半角英数12桁まで"
                v-bind:rules="[
                    validation.userCode.required,
                    validation.userCode.alphaNum,
                    validation.userCode.maxLength,
                    ]"
                maxlength="12"
                v-model="addForm.user_code"
                v-bind:error-messages="errors.user_code"
                v-bind:readonly="this.isEditRole"
                @input="clearError('user_code')"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-3"></v-divider>
        <v-row
            justify="center"
            align-content="center"
        >
          <v-col cols="3">
            <v-subheader>担当者名<span class="required_mark">*</span></v-subheader>
          </v-col>
          <v-col cols="8" class="input-col">
            <v-text-field
                outlined
                dense
                name="name"
                type="text"
                maxlength="50"
                v-bind:rules="[
                    validation.userName.required
                    ]"
                v-model="addForm.name"
                v-bind:error-messages="errors.name"
                v-bind:readonly="this.isEditRole"
                @input="clearError('name')"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-3"></v-divider>
        <v-row
            justify="center"
            align-content="center"
        >
          <v-col cols="3">
            <v-subheader>有効期限<span class="required_mark">*</span></v-subheader>
          </v-col>
          <v-col cols="4" class="input-col">
            <v-menu
                v-model="menuFrom"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
                v-bind:disabled="this.isEditRole"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    outlined
                    dense
                    label="開始"
                    name="expires_date_from"
                    v-bind:rules="[
                    validation.expireDateFrom.required
                  ]"
                    v-model="addForm.expires_date_from"
                    v-bind:error-messages="errors.expires_date_from"
                    v-bind="attrs"
                    v-on="on"
                    readlonly
                    append-icon="mdi-calendar"
                    v-bind:readonly="isEditRole"
                />
              </template>
              <v-date-picker
                  v-model="addForm.expires_date_from"
                  @input="menuFrom = false"
                  @change="clearError('expires_date_from');this.confirmDate"
                  locale="jp-ja"
                  :day-format="date => new Date(date).getDate()"

              />
            </v-menu>
          </v-col>
          <v-col cols="4" class="input-col">
            <v-menu
                v-model="menuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
                v-bind:disabled="this.isEditRole"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    outlined
                    dense
                    label="終了"
                    name="expires_date_to"
                    v-bind:rules="[
                    validation.expireDateTo.required
                  ]"
                    v-model="addForm.expires_date_to"
                    v-bind:error-messages="errors.expires_date_to"
                    v-bind="attrs"
                    v-on="on"
                    readlonly
                    append-icon="mdi-calendar"
                    v-bind:readonly="isEditRole"
                />
              </template>
              <v-date-picker
                  v-model="addForm.expires_date_to"
                  @input="menuTo = false"
                  @change="clearError('expires_date_to');this.confirmDate"
                  locale="jp-ja"
                  :day-format="date => new Date(date).getDate()"
              />
            </v-menu>
          </v-col>
        </v-row>
        <v-divider class="mx-3"></v-divider>
        <v-row
            justify="center"
            align-content="center"
        >
          <v-col cols="3">
            <v-subheader>パスワード<span v-if="!this.isEdit" class="required_mark">*</span></v-subheader>
          </v-col>
          <v-col cols="4" class="input-col">
            <v-text-field
                outlined
                dense
                name="password"
                type="password"
                placeholder="半角英数8桁以上"
                v-bind:rules="password"
                v-model="addForm.password"
                v-bind:error-messages="errors.password"
                v-bind:readonly="(this.isEdit) ? (!this.addForm.is_change_password) : this.isEdit"
                @input="clearError('password')"
                @blur="confirmPassword"
            />
          </v-col>
          <v-col cols="4">
            <v-checkbox
                label="パスワードを変更する"
                v-model="addForm.is_change_password"
                hide-details
                v-if="this.isEdit"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-3"></v-divider>
        <v-row
            justify="center"
            align-content="center"
        >
          <v-col cols="3">
            <v-subheader>パスワード(確認)<span v-if="!this.isEdit" class="required_mark">*</span></v-subheader>
          </v-col>
          <v-col cols="4" class="input-col">
            <v-text-field
                outlined
                dense
                name="password_confirmation"
                type="password"
                v-bind:error-messages="errors.password_confirmation"
                v-model="addForm.password_confirmation"
                v-bind:rules="passwordConfirmation"
                @input="clearError('password_confirmation')"
                v-bind:readonly="(this.isEdit) ? (!this.addForm.is_change_password) : this.isEdit"
            />
          </v-col>
          <v-col cols="4"></v-col>
        </v-row>
        <v-divider class="mx-3"></v-divider>
        <v-row
            justify="center"
            align-content="center"
        >
          <v-col cols="3">
            <v-subheader>権限<span class="required_mark">*</span></v-subheader>
          </v-col>
          <v-col cols="4" class="input-col">
            <v-select
                outlined
                dense
                v-model="addForm.store_assign_role"
                :items="storeAssignRoles"
                item-text="label"
                item-value="value"
                v-bind:rules="[
                    validation.userEditRole.required
                  ]"
                v-bind:error-messages="errors.store_assign_role"
                v-bind:readonly="this.isNotEditStore"
                @input="clearError('store_assign_role')"
            />
          </v-col>
          <v-col cols="4" class="input-col">
            <v-select
                outlined
                dense
                v-model="addForm.user_edit_role"
                :items="userEditRoles"
                item-text="label"
                item-value="value"
                v-bind:rules="[
                    validation.userEditRole.required
                  ]"
                v-bind:error-messages="errors.user_edit_role"
                v-bind:readonly="this.isEditRole"
                @input="clearError('user_edit_role')"
            />
          </v-col>
        </v-row>

        <div v-if="addForm.store_assign_role === '1'">
          <v-divider class="mx-3"></v-divider>
          <v-row
              justify="center"
              align-content="center"
          >
            <v-col cols="3">
              <v-subheader>店舗指定<span class="required_mark">*</span></v-subheader>
            </v-col>
            <v-col cols="8">
              <v-row
                  no-gutters
                  align="center"
                  style="font-size: 14px;"
              >
                <v-col cols="3" class="input-col">
                  {{ checkBoxes.length }}店舗指定
                </v-col>
                <v-col cols="3" class="text-right input-col">
                  {{ stores.length }}店舗表示&nbsp;&nbsp;
                </v-col>
                <v-col cols="6" class="input-col">
                  <v-text-field
                      outlined
                      dense
                      v-model="search"
                      label="検索"
                      single-line
                      class="pa-0 ma-0"
                      hide-details
                      append-outer-icon="mdi-magnify"
                      @click:append-outer="this.searchStoreList"
                  />
                </v-col>
              </v-row>
              <v-row
                  no-gutters
                  style="font-size: 14px;"
              >
                <label class="v-messages__message v-messages theme--light error--text">
                  {{ getErrorMessage('store_id_list') }}
                </label>
              </v-row>
              <v-divider class="mx-0 mt-3"></v-divider>

              <v-layout column style="max-height: 250px">
                <v-flex style="overflow: auto">
                  <v-data-table
                      v-model="checkBoxes"
                      :headers="headers"
                      :items="stores"
                      disable-pagination
                      show-select
                      item-key="id"
                      hide-default-footer
                      @toggle-select-all="this.toggleSelectAll"
                  >
                    <template v-slot:header.data-table-select v-if="this.isNotEditStore"></template>
                    <template v-slot:item.data-table-select="{ item, isSelected, select }">
                      <v-simple-checkbox
                          :value="isSelected"
                          :disabled="item.disabled"
                          @input="checkEvent(select, $event, item)"
                          :ripple="false"
                      ></v-simple-checkbox>
                    </template>

                    <!-- 未契約だった場合テキストを灰色にする -->
                    <template v-slot:item.no="{ item }">
                      <span :class="{ 'grey--text': item.agreement_web_report !== 2 }">{{ item.no }}</span>
                    </template>

                    <template v-slot:item.store_code="{ item }">
                      <span :class="{ 'grey--text': item.agreement_web_report !== 2 }">{{ item.store_code }}</span>
                    </template>

                    <template v-slot:item.store_name="{ item }">
                      <span :class="{ 'grey--text': item.agreement_web_report !== 2 }">{{ item.store_name }}</span>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-col>
          </v-row>
        </div>

        <v-divider class="ma-3"></v-divider>

        <v-row class="text-center pb-5">
          <v-col cols="12">
            <v-btn
                outlined
                class="common-cancel-btn mr-4"
                width="150px"
                @click="cancel"
            >
              キャンセル
            </v-btn>
            <v-btn
                class="common-save-btn"
                width="200px"
                @click="saveUser"
            >
              登録
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-form>
</template>

<script>
import axios from "axios";
import {sendParallelApi} from "/src/util";

export default {
  props: {
    isEdit: {
      type: Boolean,
      required: true,
    },
    urlId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    }
  },
  data: () => ({
    menuFrom: false,
    menuTo: false,
    isEditRole: false,
    isNotEditStore: true,
    search: '',
    userEditRoles: [],
    storeAssignRoles: [],
    headers: [
      {text: 'No', value: 'no', sortable: false, filterable: false,},
      {text: '店舗コード', value: 'store_code', sortable: false, filterable: false,},
      {text: '店舗名', value: 'store_name', sortable: false},
    ],
    stores: [],
    checkBoxes: [],
    addForm: {
      user_code: '',
      name: '',
      expires_date_from: '',
      expires_date_to: '',
      password: '',
      password_confirmation: '',
      user_edit_role: '1',
      store_assign_role: '1',
      store_id_list: [],
      is_change_password: false
    },
    errors: {
      password: '',
      password_confirmation: '',
      expires_date_from: '',
      expires_date_to: '',
      store_id_list: '',
    },
    validation: {
      userCode: {
        required: v => !!v || '担当者コードが入力されていません。',
        maxLength: v => v.length <= 12 || '担当者コードが12桁以内で入力されていません。',
        alphaNum: v => new RegExp('^[0-9a-zA-Z]+').test(v) || '担当者コードが半角英数字で入力されていません。',
      },
      userName: {
        required: v => !!v || '担当者名が入力されていません。',
      },
      expireDateFrom: {
        required: v => !!v || '有効期限が入力されていません。',
        confirmMessage: '終了日が開始日より前です。'
      },
      expireDateTo: {
        required: v => !!v || '有効期限が入力されていません。',
      },
      password: {
        required: v => !!v || 'パスワードが入力されていません。',
        maxlength: v => v.length >= 8 || 'パスワードが8桁以上で入力されていません。',
        alphaNum: v => new RegExp('^[0-9a-zA-Z]+').test(v) || "担当者コードが半角英数字で入力されていません。",
      },
      userEditRole: {
        required: v => !!v || '',
      },
      storeAssignRole: {
        required: v => !!v || '',
      },
      passwordCheck: {
        required: v => !!v || 'パスワード(確認)が入力されていません。',
        confirmMessage: 'パスワードが一致していません。'
      },
      storeIdList: {
        errorMessage: '店舗指定が入力されていません。'
      }
    }
  }),
  computed: {
    password() {
      const rules = []
      if (this.isEdit) {
        if (this.addForm.is_change_password) {
          rules.push(this.validation.password.required)
          rules.push(this.validation.password.maxlength)
          rules.push(this.validation.password.alphaNum)
        }
      } else {
        rules.push(this.validation.password.maxlength)
        rules.push(this.validation.password.alphaNum)
      }
      return rules;
    },
    passwordConfirmation() {
      const rules = []
      if (this.addForm.is_change_password) {
        rules.push(this.validation.password.required)
        rules.push(this.confirmPassword)
      }
      return rules;
    },
  },
  created() {
    this.initialize()
  },
  methods: {
    async initialize() {
      // 権限情報
      this.isEditRole = (this.isEdit && (this.$store.getters['auth/user_edit_role'] !== 2))
      this.isNotEditStore = this.$store.getters['auth/user_edit_role'] !== 2 || this.$store.getters['auth/store_assign_role'] !== 2

      // 初期画面情報を取得
      await this.setInitData()
    },

    setInitData() {
      // マスタ情報、担当者情報を並列で取得する
      const apis = [
        {url: '/role/userEdit', callback : this.setUserEditRoleSelect},
        {url: '/role/storeAssign', callback : this.setStoreAssignRoleSelect},
        {url: '/store', callback : this.setStoreList},
      ];

      //編集画面の場合は担当者情報を取得
      if (this.isEdit) {
        apis.push({url: '/user/' + this.$route.params.id, callback : this.getEditUser});
      }
      sendParallelApi(apis)
    },

    async saveUser() {
      this.setCheckbox()
      let response = null
      if (!this.$refs.add_form.validate()) return false;
      if (this.errors.store_id_list) return false;

      if (this.isEdit) {
        response = await axios.put('/user/' + this.urlId, this.addForm)
      } else {
        response = await axios.post('/user', this.addForm)
      }
      const result = response.data?.result || 0
      const data = response.data?.data || null
      if (result === true && data !== null) {
        let alertMsg = '担当者を登録しました。'
        if (this.isEdit) {
          alertMsg = '担当者を更新しました。'
        }
        this.$store.dispatch('modal/open', {
              isOpen: true,
              message: alertMsg,
            }
        ).then(() => {
          this.$router.push('/')
        })
      } else {
        this.errors = Object.assign(this.errors, response.data.errors)
      }
    },
    async cancel() {
      await this.$router.push('/')
    },
    confirmPassword() {
      return (this.addForm.password_confirmation === this.addForm.password) || this.validation.passwordCheck.confirmMessage
    },
    confirmDate() {
      let fromDate = this.addForm.expires_date_from
      let toDate = this.addForm.expires_date_to
      if (fromDate && toDate) {
        fromDate = new Date(fromDate)
        toDate = new Date(toDate)
        if (fromDate.getTime() > toDate.getTime()) {
          this.errors.expires_date_from = this.validation.expireDateFrom.confirmMessage
        } else {
          this.errors.expires_date_from = ''
        }
      }
    },
    async setUserEditRoleSelect(response) {
      //編集権限情報の取得
      const result = response.data?.result || 0
      const data = response.data?.data || null
      if (result === true && data !== null) {
        let tmp = [];
        for (let idx in data) {
          tmp.push({
                'value': idx,
                'label': data[idx]
              }
          )
        }
        this.userEditRoles = tmp
      }
    },
    async setStoreAssignRoleSelect(response) {
      //店舗権限情報の取得
      const result = response.data?.result || 0
      const data = response.data?.data || null
      if (result === true && data !== null) {
        let tmp = [];
        for (let idx in data) {
          tmp.push({
                'value': idx,
                'label': data[idx]
              }
          )
        }
        this.storeAssignRoles = tmp
      }
    },
    async searchStoreList() {
      //店舗コードのリストを更新
      let url = '/store';
      if (this.search !== '') {
        url += '?store_name=' + this.search;
      }
      const response = await axios.get(url)
      await this.setStoreList(response)
    },
    async setStoreList(response) {
      let disabledFlag = this.isNotEditStore
      const result = response.data?.result || 0
      const data = response.data?.data || null
      if (result === true && data !== null) {
        let tmp = []
        let rowNum = 1
        for (let idx in data) {
          tmp.push({
            'no': rowNum,
            'id': data[idx]['id'],
            'store_code': data[idx]['store_code'],
            'store_name': data[idx]['store_name'],
            'agreement_web_report': data[idx]['agreement_web_report'],
            'disabled': disabledFlag
          })
          rowNum++
        }
        this.stores = tmp
      }
    },
    setCheckbox() {
      this.addForm.store_id_list = this.checkBoxes.map(item => item.id)
    },
    async getEditUser(response) {
      const result = response.data?.result || 0
      const data = response.data?.data || null
      if (result === true && data !== null) {
        this.addForm = Object.assign(this.addForm, response.data.data)
        this.addForm.expires_date_from = this.addForm.expires_date_from.replaceAll('/', '-')
        this.addForm.expires_date_to = this.addForm.expires_date_to.replaceAll('/', '-')
        this.addForm.user_edit_role = String(this.addForm.user_edit_role)
        this.addForm.store_assign_role = String(this.addForm.store_assign_role)
        for (let idx in this.addForm.store_id_list) {
          this.checkBoxes.push({id: this.addForm.store_id_list[idx]})
        }
      } else {
        await this.$router.push('/')
      }
    },
    toggleSelectAll(event) {
      this.errors.store_id_list = (event.value ? '' : [this.validation.storeIdList.errorMessage]);
    },
    clearError(prop) {
      if (this.errors[prop])
        this.errors[prop] = ''
    },
    checkEvent(select, event, item) {
      select(event)
      this.errors.store_id_list = ''
      if (!event) {
        if ((this.checkBoxes.length === 1)) {
          if (this.checkBoxes[0].id.toString() === item.id.toString()) {
            this.errors.store_id_list = [this.validation.storeIdList.errorMessage]
          }
        }
      }
    },
    getErrorMessage(prop) {
      if (Array.isArray(this.errors[prop])) {
        return this.errors[prop][0];
      } else {
        return this.errors[prop];
      }
    },
  }
}
</script>

<style scoped>
.input-col {
  margin-top: 12px
}
</style>